import styled from '@emotion/styled';

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(10)};
  padding: ${({ theme }) => theme.spacing(8)} 0;
`;

export const RowContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(3)};
  align-items: center;
`;

export const ColumnContainer = styled(RowContainer)`
  flex-direction: column;
  align-items: flex-start;
`;

export const LabelContainer = styled(RowContainer)`
  gap: ${({ theme }) => theme.spacing(2)};
`;
